import { render } from "./MyTeam.vue?vue&type=template&id=22af1199&ts=true"
import script from "./MyTeam.vue?vue&type=script&lang=ts"
export * from "./MyTeam.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__